import {
  zAlert,
  zAlertList,
  zAlertSummary,
  type Alert,
  type AlertSeverity,
  type AlertStatus,
  type AlertSummary,
  type ListMeta,
} from '@regie/api-contract'
import { api } from '@/lib/apiClient'
import { envelope } from './unwrap'

const zAlertEnvelope = envelope('alert', zAlert)
const zAlertSummaryEnvelope = envelope('summary', zAlertSummary)

export interface AlertParams {
  // Omit for every status (open + resolved).
  status?: AlertStatus
  severity?: AlertSeverity
  // Restrict to a single site; a foreign id answers 404 like every admin resource.
  propertyId?: string
  page?: number
  perPage?: number
}

// GET /alerts — property-reported problems, most recently seen first.
export async function list(params: AlertParams = {}): Promise<{ alerts: Alert[]; meta: ListMeta }> {
  const { data } = await api.get('/alerts', { params })
  return zAlertList.parse(data)
}

// GET /alerts/summary — counts of OPEN alerts only, drives the nav badge and
// the global banner.
export async function summary(): Promise<AlertSummary> {
  const { data } = await api.get('/alerts/summary')
  return zAlertSummaryEnvelope.parse(data)
}

// POST /alerts/:id/resolve — manual close (resolvedBy: "admin"). Idempotent:
// an already-resolved alert comes back unchanged.
export async function resolve(id: string): Promise<Alert> {
  const { data } = await api.post(`/alerts/${id}/resolve`)
  return zAlertEnvelope.parse(data)
}
